import {injectable} from "inversify";
import Scene = Phaser.Scene;
import {GenderChangePanel} from "@/scenes.ui/gender-change-panel";
import {Player} from "@/store/player/types";
import {PaidFeatureDto} from "@/store/paidFeature/types";
import PaidFeatureStore from "@/store/paidFeature";
import PlayerStore from "@/store/player";

@injectable()
export class GenderChangeService {

    public async open(scene: Scene, canvas: HTMLCanvasElement, onNoMoneyCallback: () => void) {

        let player: Player = PlayerStore.getPlayer();

        await PaidFeatureStore.getPaidFeatureInfo().then((pf: PaidFeatureDto) => {

            new GenderChangePanel(scene, canvas, pf.genderChanges === 0, pf.genderChangePrice, async () => {

                // Если изумрудов меньше, чем цена, то перенаправялем в шоп
                if (player.mithril < pf.genderChangePrice && pf.genderChanges > 0) {
                    if (onNoMoneyCallback != null ) {
                        onNoMoneyCallback();
                    }
                } else {
                    await PaidFeatureStore.changeGender().then(() => {
                        window.location.reload();
                    });
                }
            }).open();

        });

    }
}
